import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";
import { type Agreement, type SignedAgreement } from "@src/appV2/Agreements/types";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { JobSearchAgreementForm } from "@src/appV2/redesign/Placements/SignJobSearchAgreement/components/JobSearchAgreementForm";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { OnboardingTitle } from "../../SharedTitle";

interface JobSearchAgreementStepContainerProps {
  agreementToSign: Agreement | SignedAgreement;
  agreementsStatus: "loading" | "error" | "success";
  onAcceptAgreement: () => Promise<void> | void;
  isOptional?: boolean;
  onSkip?: () => void;
}

export function JobSearchAgreementStepContainer(props: JobSearchAgreementStepContainerProps) {
  const {
    agreementToSign,
    agreementsStatus,
    onAcceptAgreement,
    isOptional = false,
    onSkip,
  } = props;
  const worker = useDefinedWorker();

  useLogEffect(
    APP_V2_USER_EVENTS.ONBOARDING_JOB_SEARCH_AGREEMENT_STEP_VIEWED,
    {
      hcpId: worker.userId,
      name: worker.name,
      agreementVersion: agreementToSign?.attributes.version,
      agreementKind: "job-search",
    },
    { enabled: isDefined(agreementToSign) }
  );

  return (
    <>
      <Box sx={{ pl: 4 }}>
        <OnboardingTitle text="Job Search User Agreement" />
      </Box>
      <JobSearchAgreementForm
        worker={worker}
        agreementToSign={agreementToSign}
        agreementsStatus={agreementsStatus}
        signedAtStage="SIGN_UP"
        isOptional={isOptional}
        onSkip={onSkip}
        onAcceptAgreement={async () => {
          logEvent(APP_V2_USER_EVENTS.ONBOARDING_JOB_SEARCH_AGREEMENT_SIGNED, {
            workerId: worker.userId,
            name: worker.name,
            agreementVersion: agreementToSign?.attributes.version,
            viewedAtStage: "SIGN_UP",
          });

          await onAcceptAgreement();
        }}
      />
    </>
  );
}
